<template>
  <div class="ai-pic">
    <div class="ai-pic_main">
      <p>{{ $t('tianmu.aiCreateTip') }}</p>
      <div class="entrence-btn" @click="linkToAiPaint">
        {{ $t('tianmu.enterNow') }}
      </div>
      <!-- <p class="ai-pic_main_title">
        {{ $t('tianmu.aiCreateTip') }}
      </p>
      <div class="ai-pic_main_textarea">
        <el-input
          v-model="info"
          type="textarea"
          :placeholder="$t('tianmu.sceneDescription')"
          maxlength="300"
          rows="4"
        />
        <div class="submit" @click="createImg">
          <i class="el-icon-top" />
        </div>
      </div> -->
    </div>
    <HistoryList
      ref="historyList"
      :show-entry="7"
      :device="device"
      from="feifan"
    />
    <CreateCheckModal
      :type="3"
      :visible="isCreateImgVisible"
      :image-url="currentCreateImg"
      :show-entry="7"
      :loading="isCreateLoading"
      :device="device"
      @close="isCreateImgVisible=false"
      @refreshList="refreshList"
    />
  </div>
</template>
<script>
import { TextToMedia } from '@/axios/IAi.js';
import CreateCheckModal from './CreateCheckModal.vue';
import HistoryList from './HistoryList.vue';
import { alerterror, alertsuccess, warning } from "@/assets/js/common.js";

export default {
  components: {
    CreateCheckModal,
    HistoryList
  },
  props: {
    device: {
      type: Object,
      default: () => ({})
    },
    from: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      info: '',
      currentCreateImg: '',
      isCreateImgVisible: false,
      isCreateLoading: false,
    }
  },

  watch: {
  },
  mounted() {
    //this.getHistory();
  },
  destroyed(){
  },
  methods: {
    refreshList() {
      // 通过 ref 调用子组件的 refreshList 方法
      if (this.$refs.historyList) {
        this.$refs.historyList.refreshList();
      }
    },
    async createImg() {
      const params = {
        Description: this.info,
      };

      if (!this.info) {
        warning(this, this.$t('tianmu.addDescription'));
        return;
      };

      this.isCreateLoading = true;
      this.isCreateImgVisible = true;

      const res = await TextToMedia(params);

      this.isCreateLoading = false;
      this.currentCreateImg = res.Result.FileUrl;
    },

    linkToAiPaint() {
      this.$router.push({
        name: 'aiPaint',
        params: {
          vDeviceId: this.device.VDeviceId,
          from: this.from
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
// .entrence-btn {
//   font-size: 14px;
//   color: blue;
// }

.ai-pic {
  &_main {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 98%;
    height: 150px;
    margin: 0 auto;
    line-height: 150px;

    p {
      font-size: 15px;
      background: linear-gradient(90deg, #127AE8 0%, #D85DEE 97%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      font-weight: 600;
    }
    // border-radius: 14px;
    // background: linear-gradient(270deg, #127AE8 2%, #C47BF9 100%);

    &_title { 
      padding: 8px 0 0 0;
      color: #fff;
      text-align: center;
    }

    &_textarea {
      position: relative;
      padding: 12px;
    }

    &_textarea ::v-deep textarea {
      opacity: 0.6;
    }

    .submit {
      position: absolute;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #fff;
      bottom: 20px;
      right: 20px;
      text-align: center;

      i {
        font-size: 20px;
        line-height: 32px;
        font-weight: bold;

      }
    }
  }
}

.entrence-btn {
  padding: 6px 10px;
  margin-left: 10px;
  border-radius: 20px;
  line-height: 20px;
  color: #fff;
  background: linear-gradient(270deg, #127AE8 2%, #C47BF9 100%);
  cursor: pointer;
}
</style>
